module.exports = __webpack_public_path__ + "assets/img/logo-kyaneos.0e38ad42.png";